import { Clock } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";

interface InactivityModalProps {
  open: boolean;
  onDismiss: () => void;
}

export default function InactivityModal({ open, onDismiss }: InactivityModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <Clock className="h-6 w-6 text-amber-500" />
            <AlertDialogTitle>Sua sessão está prestes a expirar</AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            Você está inativo há algum tempo. Por segurança, sua sessão será
            encerrada automaticamente em breve. Clique no botão abaixo para
            continuar logado.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onDismiss}>
            Continuar logado
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
